module.exports = __webpack_public_path__ + "static/media/tractorPlow_indigo.4711e1d4.svg";